import axios from 'axios'
import mockConfig from './mockConfig'
import Store from '../store'; //使用vuex
import {setCookie} from '../assets/js/common'
import md5 from "md5";

//初始化
function install(Vue, opt) {
  //判断是否使用mock数据
  if (opt.mock) {
    mockConfig(axios)
  }

  //创建axios实例
  const instance = axios.create({
    timeout: 10000, // 超时
    withCredentials: true // 跨域请求是否允许携带cookie
  })
  // 添加请求拦截器，注入cookie
  instance.interceptors.request.use(opt => {
    // 发送请求之前
    let token = localStorage.getItem('token')
    let sandboxToken = localStorage.getItem('sandboxToken')

    // 毫秒级时间戳
    let expireTime = new Date(localStorage.getItem('expiresIn')).getTime()
    let nowTime = new Date().getTime()
    let expireInHour = (expireTime - nowTime) / 1000 * 60 * 60
    if (token) {
      opt.headers['Authorization'] = token; // 设置token到公共header
      setCookie(md5('_' + Vue.prototype.$config.env), token, expireInHour)
    }

    if (sandboxToken) {
      setCookie(md5('_' + Vue.prototype.$config.sandboxEnv), sandboxToken, expireInHour)
    }
    return opt;
  }, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  })

  // 添加响应拦截器
  /**
   * 配置manualConfig为true：外层自行处理错误，type：1-ret不为0，2-promise捕获错误
   * 配置manualConfig为false或没有配置：内层自行弹错，外层可以添加逻辑
   **/
  instance.interceptors.response.use(response => {
    // 未登录
    if (response.data.ret === 401 || response.data.ret === 2) {
      Store.store.dispatch('clearUserInfo')
      setTimeout(() => {
        window.location.href = '/#/log-in' ;
      }, 1800)
    }
    if (response.data.ret !== 0) {
      Vue.prototype.$message.error(response.data.msg);
    }
    return response;
  }, error => {
    // 对响应错误做点什么
    Vue.prototype.$message.error('网络或服务器异常，请稍后重试！');
    return Promise.reject({
      error: error,
      type: 2
    });
  })

  //添加全局方法
  Vue.prototype.$axios = instance
}

export default {
  install
}




// WEBPACK FOOTER //
// ./src/axios/index.js